import React, { useState } from 'react';
import MoreIcon from '@ps-design-system/icons/MoreHorizontal/MoreHorizontal24';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@ps-design-system/components/Popover';
import { Button } from '@ps-design-system/components/Button';
import { Text } from '@ps-design-system/components/Text';
import DisconnectCalDialog from '../DisconnectCalDialog';
import MorePopoverStrings from './strings';

const MorePopover = () => {
  const [isDisconnectDialogOpen, setIsDisconnectDialogOpen] = useState(false);

  const openDisconnectDialog = () => {
    setIsDisconnectDialogOpen(true);
  };

  return (
    <>
      <Popover>
        <PopoverTrigger
          asChild={true}
        >
          <MoreIcon className="MorePopover_more-icon"/>
        </PopoverTrigger>
        <PopoverContent className="MorePopover_content">
          <Button
            onClick={openDisconnectDialog}
            variant="text-only"
            className="MorePopover_disconnect-button"
          >
            <Text>{MorePopoverStrings.disconnectButton}</Text>
          </Button>
        </PopoverContent>
      </Popover>
      <DisconnectCalDialog isOpen={isDisconnectDialogOpen} onOpenChange={setIsDisconnectDialogOpen}/>
    </>
  );
};

export default MorePopover;
